import { post } from "../../services";
import {
    ADD_NEW_MENU_ITEM,
    UPDATE_MENU_ITEM,
    LIST_ALL_MENU_ITEMS,
} from "../../graphql";
import {
    RESET_MENU_ITEM_DETAILS,
    RESET_ALL_MENU_ITEMS,
    SAVE_ALL_MENU_ITEMS,
    TOGGLE_LOADING,
} from "../types";

// ✅ List all menu items
export const listAllMenuItems = (requestData) => {
    return async (dispatch, getState) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });
// debugger
        const {
            menuItems: { pageSize, pageNumber, list },
        } = getState().menuItems;

        let apiResponse = await post("", {
            query: LIST_ALL_MENU_ITEMS,
            variables: {
                pageSize,
                pageNumber,
                ...requestData,
            },
        });

        if (apiResponse.data.customStatus) {
            let {
                list_all_menu_items: { data, hasMore },
            } = apiResponse.data.data;
            // console.log('💥data',data);

            let updatedList = [...list, ...data];

            dispatch({
                type: SAVE_ALL_MENU_ITEMS,
                payload: {
                    list: updatedList,
                    showViewMore: hasMore,
                    pageNumber: pageNumber + 1,
                },
            });
        }

        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

// ✅ Reset all menu items
export const resetAllMenuItems = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_ALL_MENU_ITEMS });
    };
};

// ✅ Add new menu item
export const addNewMenuItem = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: ADD_NEW_MENU_ITEM,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            await dispatch(resetAllMenuItems());
            await dispatch(listAllMenuItems());
            return true;
        }

        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};

// ✅ List menu item details
// export const listMenuItemDetails = (requestData) => {
//     return async (dispatch) => {
//         dispatch({ type: TOGGLE_LOADING, payload: true });

//         let apiResponse = await post("", {
//             query: LIST_MENU_ITEM_DETAILS,
//             variables: requestData,
//         });

//         if (apiResponse.data.customStatus) {
//             let {
//                 list_menu_item_details: { data },
//             } = apiResponse.data.data;

//             dispatch({
//                 type: SAVE_MENU_ITEM_DETAILS,
//                 payload: data,
//             });
//         }

//         dispatch({ type: TOGGLE_LOADING, payload: false });
//     };
// };

// ✅ Reset menu item details
export const resetMenuItemDetails = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_MENU_ITEM_DETAILS });
    };
};



// // ✅ Update menu item
export const updateMenuItem = (requestData) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: UPDATE_MENU_ITEM,
            variables: requestData,
        });

        if (apiResponse.data.customStatus) {
            dispatch(resetAllMenuItems());
            dispatch(listAllMenuItems());
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return true;
        }

        dispatch({ type: TOGGLE_LOADING, payload: false });
    };
};
